(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (customElements.get('faq-section')) return;

  class FaqSection extends HTMLElement {
    connectedCallback() {
      this.items = this.querySelectorAll('.faq__item');
      this.firstOpen = this.dataset.firstOpen === 'true';
      this.toggleHandlers = [];

      this.items.forEach((item, index) => {
        const content = item.querySelector('.faq__item-content');
        const toggle = item.querySelector('.faq__item-toggle');
        if (!content || !toggle) return;

        const onToggle = () => {
          const willOpen = !item.classList.contains('is-open');

          this.items.forEach((other) => {
            if (other !== item) this.setItemOpen(other, false);
          });

          this.setItemOpen(item, willOpen);
        };

        toggle.addEventListener('click', onToggle);
        this.toggleHandlers.push({ toggle, onToggle });

        if (this.firstOpen && index === 0) {
          this.setItemOpen(item, true);
        } else {
          this.setItemOpen(item, false);
        }
      });

      this.onResize = () => {
        this.items.forEach((item) => {
          if (!item.classList.contains('is-open')) return;
          const content = item.querySelector('.faq__item-content');
          if (content) {
            content.style.setProperty('--accordion-content-height', content.scrollHeight + 'px');
          }
        });
      };

      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      this.toggleHandlers.forEach(({ toggle, onToggle }) => {
        toggle.removeEventListener('click', onToggle);
      });

      if (this.onResize) {
        window.removeEventListener('resize', this.onResize);
      }
    }

    setItemOpen(item, open) {
      const content = item.querySelector('.faq__item-content');
      const toggle = item.querySelector('.faq__item-toggle');
      if (!content || !toggle) return;

      if (open) {
        // Open first, then measure: the closed state has padding-bottom 0, so a
        // scrollHeight read before the class lands is short by that padding and
        // max-height then clips the answer onto the divider.
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        content.style.setProperty('--accordion-content-height', content.scrollHeight + 'px');
      } else {
        item.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    }
  }

  customElements.define('faq-section', FaqSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-seo"] && !Shopify.designMode) return;
  try {
    
  if (customElements.get('shop-seo-accordion')) return;

  class ShopSeoAccordion extends HTMLElement {
    connectedCallback() {
      this.mobileMedia = window.matchMedia('(max-width: 1023px)');
      this.items = this.querySelectorAll('.shop-seo__item');
      this.toggleHandlers = [];

      this.items.forEach((item) => {
        const content = item.querySelector('.shop-seo__item-content');
        const toggle = item.querySelector('.shop-seo__item-toggle');
        if (!content || !toggle) return;

        const onToggle = () => {
          if (!this.mobileMedia.matches) return;
          this.setMobileState(item, content, toggle, !item.classList.contains('is-open'));
        };

        toggle.addEventListener('click', onToggle);
        this.toggleHandlers.push({ toggle, onToggle });
      });

      this.isMobile = null;
      this.onMediaChange = () => this.applyMode();
      this.mobileMedia.addEventListener('change', this.onMediaChange);
      this.applyMode();
    }

    disconnectedCallback() {
      if (this.toggleHandlers) {
        this.toggleHandlers.forEach(({ toggle, onToggle }) => {
          toggle.removeEventListener('click', onToggle);
        });
      }

      if (this.onMediaChange) {
        this.mobileMedia.removeEventListener('change', this.onMediaChange);
      }
    }

    resetDesktop(item, content, toggle) {
      item.classList.add('is-open');
      content.style.removeProperty('--accordion-content-height');
      content.style.removeProperty('max-height');
      toggle.setAttribute('aria-expanded', 'true');
    }

    setMobileState(item, content, toggle, open) {
      const contentHeight = content.scrollHeight;
      content.style.setProperty('--accordion-content-height', contentHeight + 'px');
      item.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    applyMode() {
      const isMobile = this.mobileMedia.matches;
      if (isMobile === this.isMobile) return;
      this.isMobile = isMobile;

      this.items.forEach((item) => {
        const content = item.querySelector('.shop-seo__item-content');
        const toggle = item.querySelector('.shop-seo__item-toggle');
        if (!content || !toggle) return;

        if (isMobile) {
          this.setMobileState(item, content, toggle, false);
        } else {
          this.resetDesktop(item, content, toggle);
        }
      });
    }
  }

  customElements.define('shop-seo-accordion', ShopSeoAccordion);

  } catch(e) { console.error(e); }
})();
})();
